// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inquiryDetail[data-v-347f9e32] {\n  padding: 32px;\n}\n.inquiryDetail h3[data-v-347f9e32] {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n}\n.inquiryDetail .ant-row[data-v-347f9e32] {\n  font-size: 14px;\n}\n.inquiryDetail .ant-row .ant-col span[data-v-347f9e32]:first-child {\n  display: inline-block;\n  width: 120px;\n  color: rgba(0, 0, 0, 0.85);\n  vertical-align: top;\n  text-align: right;\n  margin-right: 5px;\n  height: 30px;\n}", ""]);
// Exports
module.exports = exports;
